import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'

import { Testimonial } from '@pages/LandingPage/components/Testimonial'

import { containerSx, contentSx, testimonialContainerSx } from './styles'

const Testimonial2Section = () => {
  const { t } = useTranslation()

  return (
    <Box
      data-testid="tech-vendors-features-testimonial-2-section"
      sx={containerSx}
    >
      <Box sx={contentSx}>
        <Testimonial
          variant="dark"
          testimonialText={t(
            'Prior to enrolling in the platform, we had been doing appointment setting and it was terrible - poor results and they were getting worse by the week. We really needed an alternative to traditional lead generation but didn’t know what else we could do to connect with leads until now. I love that it gives the IT decision maker control and see how important it is for them to find us – it’s so much smarter and sounder than forcing ourselves upon IT leaders who don’t want to hear from us.'
          )}
          personName="Jessica B."
          personPosition={t('Marketing Manager')}
          containerSx={testimonialContainerSx}
        />
      </Box>
    </Box>
  )
}

export { Testimonial2Section }
